<template>
  <div class="login-page">
    <!-- 氛围背景层 -->
    <div class="login-bg">
      <div class="bg-gradient"></div>
      <div class="bg-glow bg-glow-1"></div>
      <div class="bg-particles"></div>
      <div class="bg-grid"></div>
      <div class="bg-city"></div>
      <div class="bg-property-radar" aria-hidden="true">
        <div class="radar-panel">
          <div class="radar-disc">
            <span class="radar-ring radar-ring-1"></span>
            <span class="radar-ring radar-ring-2"></span>
            <span class="radar-ring radar-ring-3"></span>
            <span class="radar-cross radar-cross-h"></span>
            <span class="radar-cross radar-cross-v"></span>
            <span class="radar-sweep"></span>
            <span class="radar-blip radar-blip-1"></span>
            <span class="radar-blip radar-blip-2"></span>
            <span class="radar-blip radar-blip-3"></span>
            <span class="radar-blip radar-blip-4"></span>
            <span class="radar-center-dot"></span>
          </div>
          <div class="radar-dataflow">
            <span class="flow-line flow-line-1"></span>
            <span class="flow-line flow-line-2"></span>
            <span class="flow-line flow-line-3"></span>
            <span class="flow-packet flow-packet-1"></span>
            <span class="flow-packet flow-packet-2"></span>
          </div>
          <div class="radar-stats">
            <div class="stat-row">
              <span class="stat-label">设备在线</span>
              <span class="stat-val">100%</span>
            </div>
            <div class="stat-bar"><span class="stat-fill"></span></div>
            <div class="stat-row">
              <span class="stat-label">告警响应</span>
              <span class="stat-val stat-live">实时</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 顶部品牌：靠左 30px -->
    <header class="login-header">
      <div class="brand">
        <span class="brand-icon" v-html="getShieldIcon('brand')"></span>
        <span class="brand-name">{{ $t('login.brand') }}</span>
      </div>
    </header>

    <div class="login-main">
      <div class="login-main-center">
      <!-- 左侧文案 + 3D 建筑 -->
      <section class="login-hero">
        <h1 class="hero-title">{{ $t('login.platformTitle') }}</h1>
        <p class="hero-subtitle">
          <span class="hero-line"></span>
          {{ $t('login.platformSlogan') }}
          <span class="hero-line"></span>
        </p>

        <div class="community-3d" aria-hidden="true">
          <div class="community-3d-orbit">
            <span class="orbit-dot orbit-dot-1"></span>
            <span class="orbit-dot orbit-dot-2"></span>
            <span class="orbit-dot orbit-dot-3"></span>
          </div>
          <div class="community-3d-stage">
            <div class="community-3d-glow"></div>
            <img
              class="community-3d-img"
              src="/img/login-community-3d.png"
              alt=""
            >
            <div class="community-3d-scan"></div>
            <div class="community-3d-ring"></div>
          </div>
          <div class="community-3d-float float-a"></div>
          <div class="community-3d-float float-b"></div>
          <div class="community-3d-float float-c"></div>
        </div>
      </section>

      <!-- 登录卡片 -->
      <section class="login-card-wrap">
        <div class="login-card">
          <div class="card-badge" v-html="getShieldIcon('card')"></div>
          <h2 class="card-title">{{ $t('login.adminTitle') }}</h2>

          <el-form :model="loginForm" :rules="rules" ref="loginForm" class="login-form">
            <el-form-item prop="username">
              <el-input
                v-model="loginForm.username"
                :placeholder="$t('login.usernamePlaceholder')"
                prefix-icon="el-icon-user"
              ></el-input>
            </el-form-item>
            <el-form-item prop="passwd">
              <el-input
                v-model="loginForm.passwd"
                type="password"
                show-password
                :placeholder="$t('login.passwordPlaceholder')"
                prefix-icon="el-icon-lock"
              ></el-input>
            </el-form-item>
            <el-form-item prop="validateCode" class="captcha-item">
              <div class="captcha-container">
                <el-input
                  v-model="loginForm.validateCode"
                  :placeholder="$t('login.captchaPlaceholder')"
                  prefix-icon="el-icon-key"
                ></el-input>
                <img :src="captchaUrl" @click="refreshCaptcha" class="captcha-img" :alt="$t('login.captcha')">
              </div>
            </el-form-item>
            <el-form-item class="submit-item">
              <el-button
                class="login-btn"
                type="primary"
                @click="submitForm('loginForm')"
                :loading="loading"
              >{{ $t('login.login') }}</el-button>
            </el-form-item>
          </el-form>

          <div class="copyright">©2020-2026 <span v-html="companyName"></span></div>
        </div>
      </section>
      </div>
    </div>

    <select-login-user ref="selectLoginUserRef" @select="handleSelect"></select-login-user>
  </div>
</template>

<script>
import { login, getCaptcha, _loadStaffPrivileges } from '@/api/user/loginApi';
import { _loadCommunityInfo } from '@/api/community/communityApi';
import { listSystemInfo } from '@/api/system/systemInfoManageApi'
import selectLoginUser from '@/components/user/selectLoginUser.vue';

function getShieldIcon(id) {
  return `
<svg viewBox="0 0 48 56" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient id="shieldGrad-${id}" x1="0%" y1="0%" x2="100%" y2="100%">
      <stop offset="0%" stop-color="#4de8ff"/>
      <stop offset="100%" stop-color="#6b7cff"/>
    </linearGradient>
    <filter id="shieldGlow-${id}" x="-40%" y="-40%" width="180%" height="180%">
      <feGaussianBlur stdDeviation="2.5" result="blur"/>
      <feMerge>
        <feMergeNode in="blur"/>
        <feMergeNode in="SourceGraphic"/>
      </feMerge>
    </filter>
  </defs>
  <path filter="url(#shieldGlow-${id})" fill="url(#shieldGrad-${id})" d="M24 2 L42 10 V26 C42 40 32 50 24 54 C16 50 6 40 6 26 V10 Z"/>
  <path fill="#fff" d="M15 28 L24 20 L33 28 V38 H27 V32 H21 V38 H15 Z"/>
</svg>`;
}

export default {
  name: 'Login',
  data() {
    return {
      logo: '',
      companyName: '',
      loginForm: {
        username: '',
        passwd: '',
        validateCode: ''
      },
      captchaUrl: '',
      loading: false,
      rules: {
        username: [
          { required: true, message: this.$t('login.usernamePlaceholder'), trigger: 'blur' }
        ],
        passwd: [
          { required: true, message: this.$t('login.passwordPlaceholder'), trigger: 'blur' }
        ],
        validateCode: [
          { required: true, message: this.$t('login.captchaPlaceholder'), trigger: 'blur' }
        ]
      }
    };
  },
  created() {
    localStorage.clear();
    this.getSystemInfo();
    setTimeout(() => {
      this.refreshCaptcha();
    }, 1000);
  },
  components: {
    selectLoginUser
  },
  methods: {
    getShieldIcon,
    async getSystemInfo() {
      const { data } = await listSystemInfo({ page: 1, row: 1 });
      this.logo = data[0].logoUrl;
      this.companyName = data[0].companyName;
    },
    async submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.loading = true;
          try {
            const { data } = await login(this.loginForm).catch(error => {
              this.$message.error(error);
              this.refreshCaptcha();
              return { data: [] };
            });
            if (!data || data.length == 0) {
              return;
            }

            if (data && data.length > 1) {
              this.$refs.selectLoginUserRef.openDialog(data);
              return;
            }
            this.handleSelect(data[0]);
          } catch (error) {
            console.error('登录失败：', error);
            this.refreshCaptcha();
          } finally {
            this.loading = false;
          }
        } else {
          return false;
        }
      });
    },
    async handleSelect(_userData) {
      localStorage.setItem('token', _userData.token);
      let _user = {
        userId: _userData.userId,
        name: _userData.name,
        tel: _userData.tel
      };
      localStorage.setItem('user', JSON.stringify(_user));
      await _loadStaffPrivileges();
      await _loadCommunityInfo();
      this.$router.push('/');
    },
    async refreshCaptcha() {
      try {
        const res = await getCaptcha();
        this.captchaUrl = res;
      } catch (error) {
        this.$message.error(this.$t('login.getCaptchaFailed'));
      }
    }
  }
};
</script>

<style scoped>
.login-page {
  --cyan: #3de7ff;
  --cyan-soft: rgba(61, 231, 255, 0.45);
  --purple: #8b5cff;
  --purple-deep: #2a0a5c;
  --navy: #06103a;
  --glass: rgba(12, 24, 72, 0.45);
  --text: #ffffff;
  --muted: rgba(255, 255, 255, 0.65);

  position: relative;
  min-height: 100vh;
  overflow: hidden;
  color: var(--text);
  font-family: "PingFang SC", "Microsoft YaHei", "Helvetica Neue", Arial, sans-serif;
  background: #050a28;
}

/* ========== 背景 ========== */
.login-bg {
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 0;
}

.bg-gradient {
  position: absolute;
  inset: 0;
  background:
    radial-gradient(ellipse 80% 50% at 70% 20%, rgba(90, 40, 180, 0.55), transparent 60%),
    radial-gradient(ellipse 60% 40% at 20% 30%, rgba(30, 80, 200, 0.35), transparent 55%),
    linear-gradient(160deg, #050a28 0%, #12083f 45%, #1a0a4a 70%, #0a1640 100%);
}

.bg-glow {
  position: absolute;
  border-radius: 50%;
  filter: blur(60px);
}

.bg-glow-1 {
  width: 420px;
  height: 420px;
  top: -80px;
  right: 12%;
  background: rgba(80, 120, 255, 0.35);
  animation: floatGlow 8s ease-in-out infinite;
}

.bg-particles {
  position: absolute;
  inset: 0;
  background-image:
    radial-gradient(2px 2px at 15% 25%, rgba(255, 255, 255, 0.5), transparent),
    radial-gradient(1.5px 1.5px at 35% 60%, rgba(61, 231, 255, 0.6), transparent),
    radial-gradient(2px 2px at 55% 18%, rgba(255, 255, 255, 0.35), transparent),
    radial-gradient(1.5px 1.5px at 72% 45%, rgba(139, 92, 255, 0.55), transparent),
    radial-gradient(2px 2px at 88% 70%, rgba(61, 231, 255, 0.45), transparent),
    radial-gradient(1px 1px at 42% 80%, rgba(255, 255, 255, 0.4), transparent),
    radial-gradient(1.5px 1.5px at 10% 75%, rgba(255, 255, 255, 0.3), transparent);
  animation: twinkle 6s ease-in-out infinite;
}

.bg-grid {
  position: absolute;
  left: -10%;
  right: -10%;
  bottom: -5%;
  height: 42%;
  background-image:
    linear-gradient(rgba(61, 231, 255, 0.22) 1px, transparent 1px),
    linear-gradient(90deg, rgba(61, 231, 255, 0.22) 1px, transparent 1px);
  background-size: 56px 56px;
  transform: perspective(420px) rotateX(58deg);
  transform-origin: center bottom;
  mask-image: linear-gradient(to top, rgba(0, 0, 0, 0.85), transparent 85%);
  -webkit-mask-image: linear-gradient(to top, rgba(0, 0, 0, 0.85), transparent 85%);
  opacity: 0.55;
}

.bg-city {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 8%;
  height: 28%;
  background:
    linear-gradient(180deg, transparent 0%, rgba(8, 20, 60, 0.4) 100%),
    repeating-linear-gradient(
      90deg,
      transparent 0,
      transparent 18px,
      rgba(61, 231, 255, 0.08) 18px,
      rgba(61, 231, 255, 0.08) 20px
    );
  clip-path: polygon(
    0% 100%, 0% 72%, 3% 72%, 3% 48%, 7% 48%, 7% 62%, 11% 62%, 11% 35%,
    15% 35%, 15% 55%, 18% 55%, 18% 28%, 22% 28%, 22% 50%, 26% 50%, 26% 40%,
    30% 40%, 30% 65%, 34% 65%, 34% 22%, 39% 22%, 39% 45%, 44% 45%, 44% 30%,
    48% 30%, 48% 58%, 52% 58%, 52% 18%, 58% 18%, 58% 42%, 63% 42%, 63% 55%,
    68% 55%, 68% 25%, 73% 25%, 73% 48%, 78% 48%, 78% 32%, 83% 32%, 83% 60%,
    88% 60%, 88% 38%, 93% 38%, 93% 70%, 100% 70%, 100% 100%
  );
  border-top: 1px solid rgba(61, 231, 255, 0.25);
  box-shadow: 0 0 40px rgba(61, 231, 255, 0.15);
  opacity: 0.7;
}

/* ========== 右上：物业全域监测雷达（与左侧 3D 建筑区分） ========== */
.bg-property-radar {
  position: absolute;
  right: 7%;
  top: 12%;
  width: 220px;
  height: 200px;
  pointer-events: none;
  animation: radarPanelFloat 7s ease-in-out infinite;
}

.radar-panel {
  position: relative;
  width: 100%;
  height: 100%;
}

.radar-disc {
  position: absolute;
  left: 0;
  top: 10px;
  width: 130px;
  height: 130px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(8, 24, 64, 0.75) 0%, rgba(8, 20, 50, 0.45) 70%, transparent 100%);
  border: 1px solid rgba(61, 231, 255, 0.28);
  overflow: hidden;
}

.radar-ring {
  position: absolute;
  left: 50%;
  top: 50%;
  border-radius: 50%;
  border: 1px solid rgba(61, 231, 255, 0.15);
  transform: translate(-50%, -50%);
}

.radar-ring-1 { width: 40%; height: 40%; }
.radar-ring-2 { width: 70%; height: 70%; }
.radar-ring-3 { width: 96%; height: 96%; border-color: rgba(155, 77, 255, 0.2); }

.radar-cross {
  position: absolute;
  background: rgba(61, 231, 255, 0.12);
}

.radar-cross-h {
  left: 4%;
  top: 50%;
  width: 92%;
  height: 1px;
  transform: translateY(-50%);
}

.radar-cross-v {
  left: 50%;
  top: 4%;
  width: 1px;
  height: 92%;
  transform: translateX(-50%);
}

.radar-sweep {
  position: absolute;
  inset: 0;
  border-radius: 50%;
  background: conic-gradient(
    from 0deg at 50% 50%,
    rgba(61, 231, 255, 0.42) 0deg,
    rgba(61, 231, 255, 0.1) 32deg,
    transparent 48deg,
    transparent 360deg
  );
  animation: radarSweep 4s linear infinite;
}

.radar-center-dot {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 6px;
  height: 6px;
  margin: -3px 0 0 -3px;
  border-radius: 50%;
  background: #3de7ff;
  box-shadow: 0 0 10px rgba(61, 231, 255, 0.9);
}

.radar-blip {
  position: absolute;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #3de7ff;
  animation: radarBlip 4s ease-in-out infinite;
}

.radar-blip-1 { left: 62%; top: 28%; animation-delay: 0.4s; }
.radar-blip-2 { left: 38%; top: 55%; background: #9b4dff; animation-delay: 1.6s; }
.radar-blip-3 { left: 72%; top: 62%; background: #ffe066; animation-delay: 2.8s; }
.radar-blip-4 { left: 24%; top: 34%; animation-delay: 3.5s; }

.radar-dataflow {
  position: absolute;
  right: 28px;
  top: 18px;
  width: 3px;
  height: 110px;
}

.flow-line {
  position: absolute;
  left: 0;
  width: 1px;
  height: 100%;
  background: linear-gradient(180deg, transparent, rgba(61, 231, 255, 0.35), transparent);
}

.flow-line-1 { left: 0; }
.flow-line-2 { left: 8px; opacity: 0.6; }
.flow-line-3 { left: 16px; opacity: 0.35; }

.flow-packet {
  position: absolute;
  left: -2px;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #3de7ff;
  box-shadow: 0 0 8px rgba(61, 231, 255, 0.85);
  animation: flowPacket 2.4s linear infinite;
}

.flow-packet-2 {
  left: 6px;
  background: #9b4dff;
  box-shadow: 0 0 8px rgba(155, 77, 255, 0.85);
  animation-delay: 1.2s;
}

.radar-stats {
  position: absolute;
  right: 0;
  bottom: 8px;
  width: 118px;
  padding: 10px 12px;
  border-radius: 10px;
  background: rgba(10, 22, 60, 0.55);
  border: 1px solid rgba(61, 231, 255, 0.22);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
}

.stat-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
}

.stat-label {
  font-size: 10px;
  color: rgba(255, 255, 255, 0.55);
  letter-spacing: 1px;
}

.stat-val {
  font-size: 11px;
  font-weight: 600;
  color: #3de7ff;
  font-family: "Consolas", "Monaco", monospace;
}

.stat-live {
  color: #5dffaa;
  animation: statLiveBlink 2s ease-in-out infinite;
}

.stat-bar {
  height: 3px;
  margin-bottom: 8px;
  border-radius: 2px;
  background: rgba(255, 255, 255, 0.08);
  overflow: hidden;
}

.stat-fill {
  display: block;
  height: 100%;
  width: 100%;
  border-radius: 2px;
  background: linear-gradient(90deg, #3de7ff, #9b4dff);
}

/* ========== 顶栏：品牌靠左 30px ========== */
.login-header {
  position: relative;
  z-index: 2;
  padding: 28px 0 0 30px;
  text-align: left;
}

.brand {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  margin: 0;
}

.brand-icon {
  display: inline-flex;
  width: 36px;
  height: 42px;
  filter: drop-shadow(0 0 10px rgba(61, 231, 255, 0.65));
}

.brand-name {
  font-size: 20px;
  font-weight: 600;
  letter-spacing: 1px;
  color: #fff;
  text-shadow: 0 0 12px rgba(61, 231, 255, 0.35);
}

/* ========== 主体布局：两板块水平居中 ========== */
.login-main {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 90px);
  padding: 24px 30px 40px;
  box-sizing: border-box;
}

.login-main-center {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 72px;
  width: 100%;
  max-width: 1100px;
}

.login-hero {
  flex: 0 1 520px;
  max-width: 520px;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.hero-title {
  margin: 0 0 22px;
  font-size: 46px;
  font-weight: 700;
  line-height: 1.25;
  letter-spacing: 2px;
  color: #fff;
  text-shadow:
    0 0 24px rgba(61, 231, 255, 0.35),
    0 4px 24px rgba(0, 0, 0, 0.35);
}

.hero-subtitle {
  display: flex;
  align-items: center;
  gap: 16px;
  margin: 0 0 28px;
  font-size: 16px;
  color: rgba(255, 255, 255, 0.88);
  letter-spacing: 4px;
}

.hero-line {
  display: inline-block;
  width: 56px;
  height: 2px;
  background: linear-gradient(90deg, transparent, var(--cyan), transparent);
  box-shadow: 0 0 12px var(--cyan-soft);
  position: relative;
}

.hero-line::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 0 14px 4px rgba(61, 231, 255, 0.9);
  transform: translate(-50%, -50%);
}

/* ========== 智慧社区 3D 动态展示 ========== */
.community-3d {
  position: relative;
  width: 100%;
  max-width: 520px;
  height: 320px;
  margin-top: 8px;
  perspective: 900px;
}

.community-3d-stage {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transform-style: preserve-3d;
  animation: communityFloat 5.5s ease-in-out infinite;
}

.community-3d-glow {
  position: absolute;
  left: 50%;
  bottom: 18%;
  width: 70%;
  height: 48px;
  transform: translateX(-50%);
  background: radial-gradient(ellipse at center, rgba(80, 160, 255, 0.45), transparent 70%);
  filter: blur(8px);
  pointer-events: none;
}

.community-3d-img {
  position: relative;
  z-index: 2;
  width: 100%;
  max-width: 480px;
  height: auto;
  object-fit: contain;
  filter: drop-shadow(0 12px 24px rgba(20, 60, 160, 0.4));
  animation: communitySway 9s ease-in-out infinite;
  user-select: none;
  pointer-events: none;
}

.community-3d-scan {
  position: absolute;
  left: 12%;
  right: 12%;
  top: 18%;
  height: 2px;
  z-index: 3;
  background: linear-gradient(90deg, transparent, rgba(61, 231, 255, 0.85), transparent);
  box-shadow: 0 0 12px rgba(61, 231, 255, 0.7);
  animation: communityScan 3.8s linear infinite;
  pointer-events: none;
  opacity: 0.7;
}

.community-3d-ring {
  position: absolute;
  left: 50%;
  bottom: 10%;
  width: 62%;
  height: 42px;
  transform: translateX(-50%) rotateX(70deg);
  border: 1px solid rgba(61, 231, 255, 0.35);
  border-radius: 50%;
  box-shadow:
    0 0 16px rgba(61, 231, 255, 0.25),
    inset 0 0 12px rgba(61, 231, 255, 0.15);
  animation: communityRing 4s ease-in-out infinite;
  pointer-events: none;
}

.community-3d-orbit {
  position: absolute;
  inset: 8% 10%;
  border-radius: 50%;
  border: 1px dashed rgba(61, 231, 255, 0.18);
  animation: communityOrbit 14s linear infinite;
  pointer-events: none;
}

.orbit-dot {
  position: absolute;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #3de7ff;
  box-shadow: 0 0 10px rgba(61, 231, 255, 0.9);
}

.orbit-dot-1 { top: 0; left: 50%; }
.orbit-dot-2 { right: 8%; bottom: 28%; background: #9b4dff; box-shadow: 0 0 10px rgba(155, 77, 255, 0.9); }
.orbit-dot-3 { left: 12%; bottom: 18%; background: #ffe066; box-shadow: 0 0 10px rgba(255, 224, 102, 0.85); }

.community-3d-float {
  position: absolute;
  border-radius: 4px;
  background: linear-gradient(135deg, rgba(61, 231, 255, 0.55), rgba(90, 120, 255, 0.35));
  box-shadow: 0 0 12px rgba(61, 231, 255, 0.45);
  pointer-events: none;
}

.float-a {
  width: 14px;
  height: 22px;
  top: 22%;
  right: 8%;
  animation: particleFloat 4.2s ease-in-out infinite;
}

.float-b {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  top: 38%;
  left: 6%;
  background: radial-gradient(circle, #ffe066, #ffb020);
  animation: particleFloat 5s ease-in-out infinite 0.6s;
}

.float-c {
  width: 18px;
  height: 12px;
  bottom: 28%;
  right: 18%;
  opacity: 0.8;
  animation: particleFloat 4.8s ease-in-out infinite 1.1s;
}

/* ========== 登录卡片 ========== */
.login-card-wrap {
  flex: 0 0 400px;
  width: 400px;
  padding-top: 36px;
}

.login-card {
  position: relative;
  padding: 52px 36px 28px;
  border-radius: 18px;
  background: linear-gradient(
    145deg,
    rgba(20, 40, 100, 0.55) 0%,
    rgba(30, 20, 80, 0.5) 50%,
    rgba(40, 20, 90, 0.55) 100%
  );
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
  border: 1.5px solid transparent;
  background-clip: padding-box;
  box-shadow:
    0 0 0 1.5px transparent,
    0 20px 50px rgba(0, 0, 0, 0.45),
    0 0 40px rgba(61, 231, 255, 0.12),
    inset 0 1px 0 rgba(255, 255, 255, 0.12);
}

.login-card::before {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: 18px;
  padding: 1.5px;
  background: linear-gradient(
    135deg,
    rgba(61, 231, 255, 0.95) 0%,
    rgba(100, 140, 255, 0.55) 40%,
    rgba(180, 80, 255, 0.85) 100%
  );
  -webkit-mask:
    linear-gradient(#fff 0 0) content-box,
    linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
  mask:
    linear-gradient(#fff 0 0) content-box,
    linear-gradient(#fff 0 0);
  mask-composite: exclude;
  pointer-events: none;
  box-shadow: 0 0 20px rgba(61, 231, 255, 0.35);
}

.card-badge {
  position: absolute;
  top: -34px;
  left: 50%;
  transform: translateX(-50%);
  width: 64px;
  height: 74px;
  filter: drop-shadow(0 0 16px rgba(61, 231, 255, 0.75));
  animation: badgePulse 3s ease-in-out infinite;
}

.card-title {
  margin: 8px 0 28px;
  text-align: center;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: 2px;
  color: #fff;
}

.login-form {
  width: 100%;
}

.login-form ::v-deep .el-form-item {
  margin-bottom: 18px;
}

.login-form ::v-deep .el-form-item__error {
  padding-top: 4px;
}

.login-form ::v-deep .el-input__inner {
  height: 46px;
  line-height: 46px;
  border-radius: 10px;
  background: rgba(8, 16, 48, 0.55) !important;
  border: 1px solid rgba(160, 180, 220, 0.35) !important;
  color: #fff !important;
  font-size: 14px;
  padding-left: 40px;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.login-form ::v-deep .el-input__inner::placeholder {
  color: rgba(200, 210, 230, 0.55);
}

.login-form ::v-deep .el-input__inner:focus {
  border-color: rgba(61, 231, 255, 0.75) !important;
  box-shadow: 0 0 12px rgba(61, 231, 255, 0.25);
}

.login-form ::v-deep .el-input__prefix {
  left: 10px;
}

.login-form ::v-deep .el-input__icon {
  line-height: 46px;
  color: rgba(160, 200, 255, 0.7);
  font-size: 16px;
}

.login-form ::v-deep .el-input__suffix {
  right: 8px;
}

.login-form ::v-deep .el-input__suffix .el-input__icon {
  color: rgba(160, 200, 255, 0.7);
}

.captcha-container {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
}

.captcha-container ::v-deep .el-input {
  flex: 1;
}

.captcha-img {
  height: 46px;
  width: 110px;
  flex-shrink: 0;
  border-radius: 8px;
  cursor: pointer;
  object-fit: cover;
  border: 1px solid rgba(160, 180, 220, 0.35);
  background: rgba(255, 255, 255, 0.9);
  transition: opacity 0.2s;
}

.captcha-img:hover {
  opacity: 0.85;
}

.submit-item {
  margin-bottom: 8px !important;
  margin-top: 8px;
}

.login-btn {
  width: 100%;
  height: 46px;
  border: none !important;
  border-radius: 12px !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  letter-spacing: 2px;
  color: #fff !important;
  background: linear-gradient(90deg, #2ec8ff 0%, #5b7dff 50%, #9b4dff 100%) !important;
  box-shadow: 0 6px 24px rgba(80, 120, 255, 0.45);
  transition: transform 0.2s, box-shadow 0.2s, filter 0.2s;
}

.login-btn:hover,
.login-btn:focus {
  filter: brightness(1.08);
  box-shadow: 0 8px 28px rgba(61, 231, 255, 0.5);
  color: #fff !important;
}

.login-btn:active {
  transform: scale(0.98);
}

.copyright {
  margin-top: 18px;
  text-align: center;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.45);
}

/* ========== 动效 ========== */
@keyframes floatGlow {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(18px); }
}

@keyframes radarPanelFloat {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-8px); }
}

@keyframes radarSweep {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

@keyframes radarBlip {
  0%, 100% { opacity: 0.2; transform: scale(0.8); }
  15%, 35% { opacity: 1; transform: scale(1.3); box-shadow: 0 0 10px currentColor; }
  50% { opacity: 0.3; transform: scale(1); }
}

@keyframes flowPacket {
  0% { top: -4px; opacity: 0; }
  10% { opacity: 1; }
  90% { opacity: 1; }
  100% { top: 100%; opacity: 0; }
}

@keyframes statLiveBlink {
  0%, 100% { opacity: 0.65; }
  50% { opacity: 1; }
}

@keyframes twinkle {
  0%, 100% { opacity: 0.7; }
  50% { opacity: 1; }
}

@keyframes badgePulse {
  0%, 100% { filter: drop-shadow(0 0 12px rgba(61, 231, 255, 0.65)); }
  50% { filter: drop-shadow(0 0 22px rgba(61, 231, 255, 0.95)); }
}

@keyframes communityFloat {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-12px); }
}

@keyframes communitySway {
  0%, 100% { transform: rotateY(-6deg) rotateX(2deg) scale(1); }
  50% { transform: rotateY(6deg) rotateX(-1deg) scale(1.02); }
}

@keyframes communityScan {
  0% { top: 18%; opacity: 0; }
  10% { opacity: 0.75; }
  90% { opacity: 0.75; }
  100% { top: 78%; opacity: 0; }
}

@keyframes communityRing {
  0%, 100% { opacity: 0.45; transform: translateX(-50%) rotateX(70deg) scale(1); }
  50% { opacity: 0.85; transform: translateX(-50%) rotateX(70deg) scale(1.06); }
}

@keyframes communityOrbit {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

@keyframes particleFloat {
  0%, 100% { transform: translateY(0) translateX(0); opacity: 0.55; }
  50% { transform: translateY(-16px) translateX(6px); opacity: 1; }
}

/* ========== 响应式 ========== */
@media (max-width: 960px) {
  .login-main {
    padding: 20px 20px 40px;
  }

  .login-main-center {
    flex-direction: column;
    gap: 28px;
    max-width: 100%;
  }

  .login-hero {
    flex: none;
    max-width: 100%;
    align-items: center;
    text-align: center;
  }

  .hero-title {
    font-size: 32px;
  }

  .hero-subtitle {
    justify-content: center;
    letter-spacing: 2px;
    font-size: 14px;
  }

  .community-3d {
    height: 240px;
    max-width: 360px;
  }

  .login-card-wrap {
    flex: none;
    width: 100%;
    max-width: 400px;
  }

  .login-header {
    padding: 20px 0 0 30px;
  }

  .bg-property-radar {
    display: none;
  }
}
</style>
